export const shapesCountries = [
    {
        category: 'Countries',
        key: 'argentina',
        name: 'Argentina',
        path: "/shapes/argentina.png"
    },
    {
        category: 'Countries',
        key: 'albania',
        name: 'Albania',
        path: "/shapes/albania.png"
    },
    {
        category: 'Countries',
        key: 'algeria',
        name: 'Algeria',
        path: "/shapes/algeria.png"
    },
    {
        category: 'Countries',
        key: 'andorra',
        name: 'Andorra',
        path: "/shapes/andorra.png"
    },
    {
        category: 'Countries',
        key: 'angola',
        name: 'Angola',
        path: "/shapes/angola.png"
    },
    {
        category: 'Countries',
        key: 'afghanistan',
        name: 'Afghanistan',
        path: "/shapes/afghanistan.png"
    },
    {
        category: 'Countries',
        key: 'australia',
        name: 'Australia',
        path: "/shapes/australia.png"
    },
    {
        category: 'Countries',
        key: 'austria',
        name: 'Austria',
        path: "/shapes/austria.png"
    },
    {
        category: 'Countries',
        key: 'bangladesh',
        name: 'Bangladesh',
        path: "/shapes/bangladesh.png"
    },
    {
        category: 'Countries',
        key: 'belarus',
        name: 'Belarus',
        path: "/shapes/belarus.png"
    },
    {
        category: 'Countries',
        key: 'belgium',
        name: 'Belgium',
        path: "/shapes/belgium.png"
    },
    {
        category: 'Countries',
        key: 'botswana',
        name: 'Botswana',
        path: "/shapes/botswana.png"
    },
    {
        category: 'Countries',
        key: 'bolivia',
        name: 'Bolivia',
        path: "/shapes/bolivia.png"
    },
    {
        category: 'Countries',
        key: 'bosnia_and_herzegovina',
        name: 'Bosnia and Herzegovina',
        path: "/shapes/bosnia_and_herzegovina.png"
    },
    {
        category: 'Countries',
        key: 'brazil',
        name: 'Brazil',
        path: "/shapes/brazil.png"
    },
    {
        category: 'Countries',
        key: 'cambodia',
        name: 'Cambodia',
        path: "/shapes/cambodia.png"
    },
    {
        category: 'Countries',
        key: 'bulgaria',
        name: 'Bulgaria',
        path: "/shapes/bulgaria.png"
    },
    {
        category: 'Countries',
        key: 'cameroon',
        name: 'Cameroon',
        path: "/shapes/cameroon.png"
    },
    {
        category: 'Countries',
        key: 'canada',
        name: 'Canada',
        path: "/shapes/canada.png"
    },
    {
        category: 'Countries',
        key: 'chile',
        name: 'Chile',
        path: "/shapes/chile.png"
    },
    {
        category: 'Countries',
        key: 'china',
        name: 'China',
        path: "/shapes/china.png"
    },
    {
        category: 'Countries',
        key: 'colombia',
        name: 'Colombia',
        path: "/shapes/colombia.png"
    },
    {
        category: 'Countries',
        key: 'costa_rica',
        name: 'Costa Rica',
        path: "/shapes/costa_rica.png"
    },
    {
        category: 'Countries',
        key: 'croatia',
        name: 'Croatia',
        path: "/shapes/croatia.png"
    },
    {
        category: 'Countries',
        key: 'cuba',
        name: 'Cuba',
        path: "/shapes/cuba.png"
    },
    {
        category: 'Countries',
        key: 'cyprus',
        name: 'Cyprus',
        path: "/shapes/cyprus.png"
    },
    {
        category: 'Countries',
        key: 'czech_republic',
        name: 'Czech Republic',
        path: "/shapes/czech_republic.png"
    },
    {
        category: 'Countries',
        key: 'democratic_republic_of_congo',
        name: 'Democratic Republic of the Congo',
        path: "/shapes/democratic_republic_of_congo.png"
    },
    {
        category: 'Countries',
        key: 'denmark',
        name: 'Denmark',
        path: "/shapes/denmark.png"
    },
    {
        category: 'Countries',
        key: 'dominican_republic',
        name: 'Dominican Republic',
        path: "/shapes/dominican_republic.png"
    },
    {
        category: 'Countries',
        key: 'ecuador',
        name: 'Ecuador',
        path: "/shapes/ecuador.png"
    },
    {
        category: 'Countries',
        key: 'el_salvador',
        name: 'El Salvador',
        path: "/shapes/el_salvador.png"
    },
    {
        category: 'Countries',
        key: 'estonia',
        name: 'Estonia',
        path: "/shapes/estonia.png"
    },
    {
        category: 'Countries',
        key: 'egypt',
        name: 'Egypt',
        path: "/shapes/egypt.png"
    },
    {
        category: 'Countries',
        key: 'ethiopia',
        name: 'Ethiopia',
        path: "/shapes/ethiopia.png"
    },
    {
        category: 'Countries',
        key: 'finland',
        name: 'Finland',
        path: "/shapes/finland.png"
    },
    {
        category: 'Countries',
        key: 'france',
        name: 'France',
        path: "/shapes/france.png"
    },
    {
        category: 'Countries',
        key: 'germany',
        name: 'Germany',
        path: "/shapes/germany.png"
    },
    {
        category: 'Countries',
        key: 'ghana',
        name: 'Ghana',
        path: "/shapes/ghana.png"
    },
    {
        category: 'Countries',
        key: 'greece',
        name: 'Greece',
        path: "/shapes/greece.png"
    },
    {
        category: 'Countries',
        key: 'guatemala',
        name: 'Guatemala',
        path: "/shapes/guatemala.png"
    },
    {
        category: 'Countries',
        key: 'honduras',
        name: 'Honduras',
        path: "/shapes/honduras.png"
    },
    {
        category: 'Countries',
        key: 'hungary',
        name: 'Hungary',
        path: "/shapes/hungary.png"
    },
    {
        category: 'Countries',
        key: 'iceland',
        name: 'Iceland',
        path: "/shapes/iceland.png"
    },
    {
        category: 'Countries',
        key: 'india',
        name: 'India',
        path: "/shapes/india.png"
    },
    {
        category: 'Countries',
        key: 'indonesia',
        name: 'Indonesia',
        path: "/shapes/indonesia.png"
    },
    {
        category: 'Countries',
        key: 'iran',
        name: 'Iran',
        path: "/shapes/iran.png"
    },
    {
        category: 'Countries',
        key: 'iraq',
        name: 'Iraq',
        path: "/shapes/iraq.png"
    },
    {
        category: 'Countries',
        key: 'ireland',
        name: 'Ireland',
        path: "/shapes/ireland.png"
    },
    {
        category: 'Countries',
        key: 'israel',
        name: 'Israel',
        path: "/shapes/israel.png"
    },
    {
        category: 'Countries',
        key: 'italy',
        name: 'Italy',
        path: "/shapes/italy.png"
    },
    {
        category: 'Countries',
        key: 'jamaica',
        name: 'Jamaica',
        path: "/shapes/jamaica.png"
    },
    {
        category: 'Countries',
        key: 'japan',
        name: 'Japan',
        path: "/shapes/japan.png"
    },
    {
        category: 'Countries',
        key: 'jordan',
        name: 'Jordan',
        path: "/shapes/jordan.png"
    },
    {
        category: 'Countries',
        key: 'kazakhstan',
        name: 'Kazakhstan',
        path: "/shapes/kazakhstan.png"
    },
    {
        category: 'Countries',
        key: 'kenya',
        name: 'Kenya',
        path: "/shapes/kenya.png"
    },
    {
        category: 'Countries',
        key: 'kuwait',
        name: 'Kuwait',
        path: "/shapes/kuwait.png"
    },
    {
        category: 'Countries',
        key: 'laos',
        name: 'Laos',
        path: "/shapes/laos.png"
    },
    {
        category: 'Countries',
        key: 'latvia',
        name: 'Latvia',
        path: "/shapes/latvia.png"
    },
    {
        category: 'Countries',
        key: 'lebanon',
        name: 'Lebanon',
        path: "/shapes/lebanon.png"
    },
    {
        category: 'Countries',
        key: 'lithuania',
        name: 'Lithuania',
        path: "/shapes/lithuania.png"
    },
    {
        category: 'Countries',
        key: 'luxembourg',
        name: 'Luxembourg',
        path: "/shapes/luxembourg.png"
    },
    {
        category: 'Countries',
        key: 'malaysia',
        name: 'Malaysia',
        path: "/shapes/malaysia.png"
    },
    {
        category: 'Countries',
        key: 'madagascar',
        name: 'Madagascar',
        path: "/shapes/madagascar.png"
    },
    {
        category: 'Countries',
        key: 'malta',
        name: 'Malta',
        path: "/shapes/malta.png"
    },
    {
        category: 'Countries',
        key: 'morocco',
        name: 'Morocco',
        path: "/shapes/morocco.png"
    },
    {
        category: 'Countries',
        key: 'mozambique',
        name: 'Mozambique',
        path: "/shapes/mozambique.png"
    },
    {
        category: 'Countries',
        key: 'myanmar',
        name: 'Myanmar',
        path: "/shapes/myanmar.png"
    },
    {
        category: 'Countries',
        key: 'mexico',
        name: 'Mexico',
        path: "/shapes/mexico.png"
    },
    {
        category: 'Countries',
        key: 'moldova',
        name: 'Moldova',
        path: "/shapes/moldova.png"
    },
    {
        category: 'Countries',
        key: 'monaco',
        name: 'Monaco',
        path: "/shapes/monaco.png"
    },
    {
        category: 'Countries',
        key: 'montenegro',
        name: 'Montenegro',
        path: "/shapes/montenegro.png"
    },
    {
        category: 'Countries',
        key: 'namibia',
        name: 'Namibia',
        path: "/shapes/namibia.png"
    },
    {
        category: 'Countries',
        key: 'nepal',
        name: 'Nepal',
        path: "/shapes/nepal.png"
    },
    {
        category: 'Countries',
        key: 'netherlands',
        name: 'Netherlands',
        path: "/shapes/netherlands.png"
    },
    {
        category: 'Countries',
        key: 'nigeria',
        name: 'Nigeria',
        path: "/shapes/nigeria.png"
    },
    {
        category: 'Countries',
        key: 'north_korea',
        name: 'North Korea',
        path: "/shapes/north_korea.png"
    },
    {
        category: 'Countries',
        key: 'new_zealand',
        name: 'New Zealand',
        path: "/shapes/new_zealand.png"
    },
    {
        category: 'Countries',
        key: 'north_macedonia',
        name: 'North Macedonia',
        path: "/shapes/north_macedonia.png"
    },
    {
        category: 'Countries',
        key: 'nicaragua',
        name: 'Nicaragua',
        path: "/shapes/nicaragua.png"
    },
    {
        category: 'Countries',
        key: 'norway',
        name: 'Norway',
        path: "/shapes/norway.png"
    },
    {
        category: 'Countries',
        key: 'pakistan',
        name: 'Pakistan',
        path: "/shapes/pakistan.png"
    },
    {
        category: 'Countries',
        key: 'panama',
        name: 'Panama',
        path: "/shapes/panama.png"
    },
    {
        category: 'Countries',
        key: 'papua_new_guinea',
        name: 'Papua New Guinea',
        path: "/shapes/papua_new_guinea.png"
    },
    {
        category: 'Countries',
        key: 'paraguay',
        name: 'Paraguay',
        path: "/shapes/paraguay.png"
    },
    {
        category: 'Countries',
        key: 'philippines',
        name: 'Philippines',
        path: "/shapes/philippines.png"
    },
    {
        category: 'Countries',
        key: 'peru',
        name: 'Peru',
        path: "/shapes/peru.png"
    },
    {
        category: 'Countries',
        key: 'poland',
        name: 'Poland',
        path: "/shapes/poland.png"
    },
    {
        category: 'Countries',
        key: 'portugal',
        name: 'Portugal',
        path: "/shapes/portugal.png"
    },
    {
        category: 'Countries',
        key: 'qatar',
        name: 'Qatar',
        path: "/shapes/qatar.png"
    },
    {
        category: 'Countries',
        key: 'romania',
        name: 'Romania',
        path: "/shapes/romania.png"
    },
    {
        category: 'Countries',
        key: 'russia',
        name: 'Russia',
        path: "/shapes/russia.png"
    },
    {
        category: 'Countries',
        key: 'san_marino',
        name: 'San Marino',
        path: "/shapes/san_marino.png"
    },
    {
        category: 'Countries',
        key: 'saudi_arabia',
        name: 'Saudi Arabia',
        path: "/shapes/saudi_arabia.png"
    },
    {
        category: 'Countries',
        key: 'senegal',
        name: 'Senegal',
        path: "/shapes/senegal.png"
    },
    {
        category: 'Countries',
        key: 'serbia',
        name: 'Serbia',
        path: "/shapes/serbia.png"
    },
    {
        category: 'Countries',
        key: 'singapore',
        name: 'Singapore',
        path: "/shapes/singapore.png"
    },
    {
        category: 'Countries',
        key: 'slovakia',
        name: 'Slovakia',
        path: "/shapes/slovakia.png"
    },
    {
        category: 'Countries',
        key: 'sri_lanka',
        name: 'Sri Lanka',
        path: "/shapes/sri_lanka.png"
    },
    {
        category: 'Countries',
        key: 'slovenia',
        name: 'Slovenia',
        path: "/shapes/slovenia.png"
    },
    {
        category: 'Countries',
        key: 'south_africa',
        name: 'South Africa',
        path: "/shapes/south_africa.png"
    },
    {
        category: 'Countries',
        key: 'south_korea',
        name: 'South Korea',
        path: "/shapes/south_korea.png"
    },
    {
        category: 'Countries',
        key: 'spain',
        name: 'Spain',
        path: "/shapes/spain.png"
    },
    {
        category: 'Countries',
        key: 'sweden',
        name: 'Sweden',
        path: "/shapes/sweden.png"
    },
    {
        category: 'Countries',
        key: 'syria',
        name: 'Syria',
        path: "/shapes/syria.png"
    },
    {
        category: 'Countries',
        key: 'switzerland',
        name: 'Switzerland',
        path: "/shapes/switzerland.png"
    },
    {
        category: 'Countries',
        key: 'taiwan',
        name: 'Taiwan',
        path: "/shapes/taiwan.png"
    },
    {
        category: 'Countries',
        key: 'tanzania',
        name: 'Tanzania',
        path: "/shapes/tanzania.png"
    },
    {
        category: 'Countries',
        key: 'thailand',
        name: 'Thailand',
        path: "/shapes/thailand.png"
    },
    {
        category: 'Countries',
        key: 'tunisia',
        name: 'Tunisia',
        path: "/shapes/tunisia.png"
    },
    {
        category: 'Countries',
        key: 'turkey',
        name: 'Turkey',
        path: "/shapes/turkey.png"
    },
    {
        category: 'Countries',
        key: 'uganda',
        name: 'Uganda',
        path: "/shapes/uganda.png"
    },
    {
        category: 'Countries',
        key: 'ukraine',
        name: 'Ukraine',
        path: "/shapes/ukraine.png"
    },
    {
        category: 'Countries',
        key: 'united_arab_emirates',
        name: 'United Arab Emirates',
        path: "/shapes/united_arab_emirates.png"
    },
    {
        category: 'Countries',
        key: 'united_kingdom',
        name: 'United Kingdom',
        path: "/shapes/united_kingdom.png"
    },
    {
        category: 'Countries',
        key: 'uruguay',
        name: 'Uruguay',
        path: "/shapes/uruguay.png"
    },
    {
        category: 'Countries',
        key: 'USA1',
        name: 'USA',
        description: 'with Alaska and Hawaii',
        path: "/shapes/usa_alaska.png"
    },
    {
        category: 'Countries',
        key: 'USA2',
        name: 'USA',
        description: 'without Alaska and Hawaii',
        path: "/shapes/usa_noAlaska.png"
    },
    {
        category: 'Countries',
        key: 'venezuela',
        name: 'Venezuela',
        path: "/shapes/venezuela.png"
    },
    {
        category: 'Countries',
        key: 'vietnam',
        name: 'Vietnam',
        path: "/shapes/vietnam.png"
    },
    {
        category: 'Countries',
        key: 'yemen',
        name: 'Yemen',
        path: "/shapes/yemen.png"
    },
    {
        category: 'Countries',
        key: 'zambia',
        name: 'Zambia',
        path: "/shapes/zambia.png"
    },
    {
        category: 'Countries',
        key: 'zimbabwe',
        name: 'Zimbabwe',
        path: "/shapes/zimbabwe.png"
    }
];